<div class="card mb-0 pt-3">
  <div
    class="card-body p-0"
    [ngClass]="{
      h150: !loadingFirstPage() && !items().length
    }"
  >
    <loading-spinner
      [isLoading]="loadingFirstPage()"
      [classesString]="'pt-88'"
      [spinnerOverlayAddedClass]="'pe-none'"
    ></loading-spinner>
    @if (noSelectedColumns()) {
      <div>
        {{ 'list.no-cols' | translate }}
        <btn [label]="'list.default-cols'" (onEvent)="loadDefaultCols()"></btn>
      </div>
    }
    <!-- Top synchronized scrollbar (shown only when content overflows) -->
    @if (showTopScroll) {
      <div class="top-scroll" #topScroll (scroll)="syncScroll('top')">
        <div class="spacer" [style.width.px]="spacerWidth"></div>
      </div>
    }

    <!-- outside the horizontal scroller so the cog stays on screen when the table overflows -->
    @if (isColumnSettingVisible() && selectedColumns()()?.length > 1 && items()) {
      <div class="column-settings-anchor">
        <dropdown
          [icon]="'far-cog'"
          [items]="columns()() | colSettings: selectedColumns()()"
          [isArrowHidden]="true"
          [autoClose]="true"
          [isColSettings]="true"
          (onResult)="onColumnSettingDropdownClick($event)"
        ></dropdown>
      </div>
    }

    <div
      class="horizontal-scroll"
      #tableWrap
      (scroll)="syncScroll('bottom')"
      [class.hide-native-scrollbar]="showTopScroll"
    >
      @if (selectedColumns()()?.length > 1 && items()) {
        <div class="table-wrap table_responsive">
          <table class="table m-0">
            <thead>
              <tr>
                @for (column of selectedColumns()(); track trackByColumnName($index, column)) {
                  @if (column.sortable && column.propType !== 'checkbox' && column.propType !== 'orders-checkbox') {
                    <th
                      class="text-nowrap {{ column.align ? ' text-' + column.align : '' }} cursor-pointer {{
                        column.cssClass || ''
                      }}"
                      (click)="sortBy(column.sortBy)"
                    >
                      <span>{{ column.name | translate }}</span>
                      <i
                        [ngClass]="
                          sortProp()() !== column.sortBy
                            ? 'far fa-caret-up ps-1'
                            : sortDir()() === 'asc'
                              ? 'fas fa-caret-up ps-1'
                              : sortDir()() === 'desc'
                                ? 'fas fa-caret-down ps-1'
                                : ''
                        "
                      >
                      </i>
                    </th>
                  }
                  <!--                TODO remove also from base listing output for fetchnext page or first, do it in child base listing on input query-->
                  @if (
                    !column.sortable &&
                    column.propType !== 'btn' &&
                    column.propType !== 'btn-right' &&
                    column.propType !== 'checkbox' &&
                    column.propType !== 'order-preview' &&
                    column.propType !== 'orders-checkbox'
                  ) {
                    <th
                      class="text-nowrap {{ column.align ? ' text-' + column.align : '' }} {{ column.cssClass || '' }}"
                      height="50px"
                    >
                      {{ listName() === 'exports' && column.propType === 'btn-gen' ? '' : (column.name | translate) }}
                    </th>
                  }
                  @if (
                    !column.sortable &&
                    (column.propType === 'btn' ||
                      column.propType === 'btn-right' ||
                      column.propType === 'order-preview')
                  ) {
                    <th class="pe-0 fixed-column-width">&nbsp;</th>
                  }
                  @if (column.propType === 'orders-checkbox') {
                    <th class="padding-th-checkbox">
                      <form-row-checkbox
                        [isOnProductsPage]="true"
                        [title]="'select.all' | translate"
                        [model]="areAllOrdersCheckboxChecked"
                        (modelChange)="allOrdersChecked($event)"
                        [dataCySelector]="'all-orders-checkbox'"
                      >
                      </form-row-checkbox>
                    </th>
                  }
                }
              </tr>
            </thead>
            @if (!loadingFirstPage() && !items().length) {
              <tbody>
                <tr>
                  <td [colSpan]="selectedColumns()().length + 1" class="text-center p-5 border-bottom-0 no-hover">
                    <div class="empty-list">
                      <i class="far fa-sad-tear" data-cy="empty"></i>
                      <div>
                        {{ 'no.record.found' | translate }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            }
            @for (item of items(); track trackByItemId($index, item)) {
              @if (!loadingFirstPage()) {
                <tbody>
                  <!--          <tr *ngFor="let item of items(); trackBy: trackByIndex">-->
                  <tr>
                    @for (column of selectedColumns()(); track trackByColumnName($index, column)) {
                      <td
                        class="{{ column.align ? ' text-' + column.align : '' }}  {{ column.cssClass || '' }}"
                        [ngClass]="{
                          'p-0':
                            column.propType === 'btn' ||
                            column.propType === 'btn-gen' ||
                            column.propType === 'modal-eet-receipt' ||
                            column.propType === 'modal-address'
                        }"
                        [ngStyle]="{ 'word-break': column.propType === 'product-link' ? 'break-all' : null }"
                      >
                        <!--SIMPLE TYPES-->
                        @if (column.propType === 'string' && item[column.property]?.length) {
                          <span title="{{ column.title | translate }}" data-cy="first-column">
                            @if (column.name === 'color') {
                              <i class="color-box" [ngStyle]="{ backgroundColor: item[column.property] }"></i>
                            } @else {
                              {{
                                (needsTranslationPrefix() && column.name === 'type'
                                  ? listName() + '.' + column.name + '.' + item[column.property]
                                  : item[column.property]
                                ) | translate
                              }}
                            }
                          </span>
                        }
                        @if (column.propType === 'product-link' && item[column.property]?.length) {
                          <span>
                            <a [routerLink]="item.product?.id ? [column.route, item.product.id] : null">
                              {{ item[column.property] | translate }}
                            </a>
                          </span>
                        }
                        @if (
                          column.propType === 'string' && item[column.property]?.name && !item[column.property].length
                        ) {
                          <span title="{{ column.title | translate }}">
                            {{ item[column.property].name | translate }}
                          </span>
                        }
                        @if (column.propType === 'link' && item[column.property]?.id) {
                          <span title="{{ column.title | translate }}">
                            <a [routerLink]="[column.route, item[column.property].id]">
                              {{
                                (item[column.property].name?.length > 2
                                  ? item[column.property].name
                                  : item[column.property].email
                                ) | translate
                              }}
                            </a>
                          </span>
                        }
                        @if (column.propType === 'priority') {
                          <span title="{{ column.title | translate }}">
                            {{ getPriorityName(item[column.property]) | translate }}
                          </span>
                        }
                        @if (column.propType === 'integer') {
                          <span title="{{ column.title | translate }}">
                            {{ item[column.property] }}
                          </span>
                        }
                        @if (column.propType === 'number') {
                          <span title="{{ column.title | translate }}">
                            {{
                              item[column.property]?.toFixed ? item[column.property].toFixed(2) : item[column.property]
                            }}
                          </span>
                        }
                        @if (column.propType === 'percent') {
                          <span title="{{ column.title | translate }}">
                            {{
                              item[column.property] !== 0 &&
                              item[column.property] !== null &&
                              item[column.property] !== undefined
                                ? item[column.property]
                                : item[column.property]
                            }}
                          </span>
                        }
                        @if (column.propType === 'price') {
                          <span title="{{ column.title | translate }}">
                            {{
                              item[column.property]
                                | formatPrice
                                  : (item.currency?.id
                                      ? item.currency
                                      : (core.services.user.user?.company?.currency | formatCurrencyWithoutPrice))
                            }}
                          </span>
                        }
                        @if (column.propType === 'price-cents') {
                          <span title="{{ column.title | translate }}">
                            {{
                              item[column.property]?.toFixed
                                ? (item[column.property] / 100).toFixed(2)
                                : item[column.property]
                            }}&nbsp;{{
                              item.currency && item.currency.id
                                ? (item.currency.id | translate)
                                : (core.services.user.user?.company?.currency | formatCurrencyWithoutPrice)
                            }}
                          </span>
                        }
                        @if (column.propType === 'date') {
                          <span title="{{ column.title | translate }}">
                            {{ item[column.property] | fmtDate: 'dd.MM.yyyy' }}
                          </span>
                        }
                        @if (column.propType === 'datetime') {
                          <span title="{{ column.title | translate }}">
                            {{ item[column.property] | fmtDate: 'dd.MM.yyyy' }}
                            {{ item[column.property] | fmtDate: 'HH:mm' }}
                          </span>
                        }
                        @if (column.propType === 'array') {
                          <span title="{{ column.title | translate }}">
                            @for (subItem of item[column.property]; track subItem) {
                              <span class="badge bg-light">
                                {{ subItem.name ? subItem.name : subItem ? subItem : ' ' }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'label') {
                          <span title="{{ column.title | translate }}">
                            @if (item[column.property]?.length) {
                              <span class="badge bg-light">
                                {{ item[column.property] }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'boolean') {
                          <span title="{{ column.title | translate }}">
                            @if (item[column.property]) {
                              <span class="badge bg-success">
                                {{ 'yes' | translate }}
                              </span>
                            }
                            @if (!item[column.property]) {
                              <span class="badge bg-danger" title="{{ column.title | translate }}">
                                {{ 'no' | translate }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'approved') {
                          <span title="{{ column.title | translate }}">
                            @if (!item.approved && !item.rejected) {
                              <span class="badge bg-light">
                                {{ 'waiting' | translate }}
                              </span>
                            }
                            @if (item.approved) {
                              <span class="badge bg-success">
                                {{ 'inventory.approved' | translate }}
                              </span>
                            }
                            @if (item.rejected) {
                              <span class="badge bg-danger">
                                {{ 'inventory.rejected' | translate }}
                              </span>
                            }
                          </span>
                        }
                        <!--CUSTOM FIELDS-->
                        @if (column.propType === 'order-preview') {
                          <span>
                            <app-order-preview [isOnOrdersPage]="true" [order]="item"></app-order-preview>
                          </span>
                        }
                        @if (column.propType === 'unavailable-number' && item['quantityUnavailable']) {
                          <div title="{{ 'products.unavailable' | translate }}" class="text-center">
                            @if (item['quantityUnavailable'] > 0) {
                              <span
                                title="{{ 'quantityUnavailable' | translate }}"
                                class="badge bg-danger"
                                style="padding-top: 0.5em"
                              >
                                {{ item['quantityUnavailable'] | number: '1.0-2' | replaceCommaToDot }}
                              </span>
                            }
                          </div>
                        }
                        @if (column.propType === 'order-preview-move-packs') {
                          <span>
                            @if (item.order?.id) {
                              <app-order-preview
                                class="display-flex-gap-03"
                                [order]="item?.order"
                                [isOrderItemsPriceSum]="true"
                              >
                              </app-order-preview>
                            }
                          </span>
                        }
                        @if (column.propType === 'img') {
                          <div [photoGalleryGroup]="{ index: 1 }" class="images">
                            @if (item.product?.id) {
                              <div
                                [photoGallery]="item.product.mainImage?.url"
                                [photoGalleryCaption]="
                                  item.product
                                    ? item.product.fullName +
                                      '<br>' +
                                      (item.product.code ? ('product.code' | translate) + item.product.code : '') +
                                      '<br>' +
                                      (item.product.ean ? ('product.ean' | translate) + item.product.ean : '')
                                    : ''
                                "
                              >
                                <div class="images-item">
                                  @if (
                                    !!item.product.mainImage?.url?.length &&
                                    !!item.product.mainImage?.thumbnails?.length
                                  ) {
                                    <img
                                      class="images-item-image"
                                      [src]="getThumbUrl(item.product.mainImage)"
                                      [alt]="item.product.fullName"
                                    />
                                  }
                                  @if (
                                    !item.product.mainImage?.url?.length || !item.product.mainImage?.thumbnails?.length
                                  ) {
                                    <img
                                      class="images-item-image"
                                      [src]="'assets/img/no-image.png'"
                                      [alt]="item.product.fullName"
                                    />
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (column.propType === 'customer-name') {
                          <span title="{{ column.title | translate }}" data-cy="customer-name">
                            @if (item['customer']?.firstName?.length || item['customer']?.lastName?.length) {
                              <div>
                                {{
                                  (item['customer'].firstName ? item['customer'].firstName : '') +
                                    ' ' +
                                    (item['customer'].lastName ? item['customer'].lastName : '')
                                }}
                              </div>
                              <div>{{ item['customer'].companyName ? item['customer'].companyName : '' }}</div>
                            }
                            @if (
                              !item['customer']?.firstName?.length &&
                              !item['customer']?.lastName?.length &&
                              (item['invoiceAddress']?.firstName?.length || item['invoiceAddress']?.lastName?.length)
                            ) {
                              <div>
                                {{
                                  (item['invoiceAddress'].firstName ? item['invoiceAddress'].firstName : '') +
                                    ' ' +
                                    (item['invoiceAddress'].lastName ? item['invoiceAddress'].lastName : '')
                                }}
                              </div>
                              <div>
                                {{ item['invoiceAddress'].companyName ? item['invoiceAddress'].companyName : '' }}
                              </div>
                            }
                            @if (
                              !item['customer']?.firstName?.length &&
                              !item['customer']?.lastName?.length &&
                              !item['invoiceAddress']?.firstName?.length &&
                              !item['invoiceAddress']?.lastName?.length &&
                              (item['shippingAddress']?.firstName?.length || item['shippingAddress']?.lastName?.length)
                            ) {
                              <div>
                                {{
                                  (item['shippingAddress'].firstName ? item['shippingAddress'].firstName : '') +
                                    ' ' +
                                    (item['shippingAddress'].lastName ? item['shippingAddress'].lastName : '')
                                }}
                              </div>
                              <div>
                                {{ item['shippingAddress'].companyName ? item['shippingAddress'].companyName : '' }}
                              </div>
                            }
                          </span>
                        }
                        @if (column.propType === 'checkout-name' && item['checkout']) {
                          <span title="{{ column.title | translate }}">
                            {{ item['checkout'].name }}
                          </span>
                        }
                        @if (column.propType === 'carrier-name' && item['carrier']) {
                          <span title="{{ column.title | translate }}">
                            <!--              <span [ngClass]="'carrier-label-' + (item.carrier.name ? item.carrier.name : '')">-->
                            {{ item.carrier.name ? item.carrier.name : '' }}
                            <!--              </span>-->
                          </span>
                        }
                        @if (
                          column.propType === 'relation-name' && item[column.property] && item[column.property].name
                        ) {
                          <span title="{{ column.title | translate }}" data-cy="relation-name">
                            {{ item[column.property].name }}
                          </span>
                        }
                        @if (column.propType === 'item-id' && item[column.property] && item[column.property].id) {
                          <span title="{{ column.title | translate }}">
                            {{ item[column.property].id }}
                          </span>
                        }
                        @if (column.propType === 'process-status' && item['processStatus']) {
                          <span
                            title="{{ column.title | translate }}"
                            [ngClass]="'process-status-' + item.processStatus.id"
                          >
                            <i
                              [ngClass]="
                                item.processStatus.id === 'recieved'
                                  ? 'far fa-cart-arrow-down'
                                  : item.processStatus.id === 'picking'
                                    ? 'far fa-scanner'
                                    : item.processStatus.id === 'packing'
                                      ? 'far fa-box-full'
                                      : item.processStatus.id === 'packed'
                                        ? 'far fa-box-check'
                                        : item.processStatus.id === 'dispatched'
                                          ? 'far fa-shipping-fast'
                                          : item.processStatus.id === 'delivered'
                                            ? 'far fa-check-circle'
                                            : item.processStatus.id === 'returned'
                                              ? 'far fa-shipping-timed'
                                              : item.processStatus.id === 'picking_error'
                                                ? 'far fa-exclamation-triangle'
                                                : item.processStatus.id === 'cancelled'
                                                  ? 'far fa-ban'
                                                  : ''
                              "
                            >
                            </i>
                            {{ item['processStatus'] ? (item['processStatus'].id | translate) : '' }}
                          </span>
                        }
                        @if (column.propType === 'icons') {
                          <div title="{{ column.title | translate }}" class="d-flex">
                            <div style="vertical-align: middle; margin-right: 3px">
                              @if (item?.quantityUnavailable < 1) {
                                <span>
                                  <i
                                    class="fas fa-person-dolly"
                                    style="color: #21d59b"
                                    [title]="'quantityUnavailable' | translate"
                                  ></i>
                                </span>
                              }
                              @if (item?.quantityUnavailable > 0) {
                                <span>
                                  <i
                                    class="fas fa-person-dolly"
                                    style="color: #f0142f"
                                    [title]="'quantityUnavailable' | translate"
                                  ></i>
                                </span>
                              }
                            </div>
                            <div style="vertical-align: middle; margin-right: 3px">
                              @if (item?.depots?.length === 1) {
                                <span>
                                  <i
                                    class="fas fa-box"
                                    style="color: #21d59b"
                                    [title]="'order.on.single.depot' | translate"
                                  ></i>
                                </span>
                              }
                              @if (item?.depots?.length > 1) {
                                <span>
                                  <i
                                    class="fas fa-boxes"
                                    style="color: #f0142f"
                                    [title]="'more.depots' | translate"
                                  ></i>
                                </span>
                              }
                            </div>
                          </div>
                        }
                        @if (column.propType === 'order-payment-items') {
                          <div title="{{ column.title | translate }}" data-cy="orders-payment-method">
                            @if (item['paymentItems']?.length) {
                              <div>
                                @for (pItem of item['paymentItems']; track pItem) {
                                  <div>
                                    <span style="vertical-align: middle; margin-right: 3px">
                                      @if (pItem?.isPaid) {
                                        <span>
                                          <i
                                            class="fas fa-usd-circle"
                                            style="color: #21d59b"
                                            [title]="'isPaid' | translate"
                                          ></i>
                                        </span>
                                      }
                                      @if (!pItem?.isPaid) {
                                        <span>
                                          <i
                                            class="fas fa-usd-circle"
                                            style="color: #f0142f"
                                            [title]="'isNotPaid' | translate"
                                          ></i>
                                        </span>
                                      }
                                    </span>
                                    {{ pItem?.payment?.name ? pItem.payment.name : '' }}
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                        @if (column.propType === 'order-payment-date-paid') {
                          <div title="{{ column.title | translate }}">
                            @for (pItem of item['paymentItems']; track pItem) {
                              @if (pItem?.isPaid && pItem?.datePaid) {
                                <div data-cy="orders-payment-datePaid">
                                  {{ pItem.datePaid | fmtDate: 'dd.MM.yyyy HH:mm' }}
                                </div>
                              }
                            }
                          </div>
                        }
                        @if (column.propType === 'order-packages') {
                          <div title="{{ column.title | translate }}">
                            @if (item['packages']?.length) {
                              <div>
                                @for (pack of item['packages']; track pack) {
                                  <div class="d-flex flex-column flex-wrap">
                                    <div>
                                      {{ pack.code }}
                                    </div>
                                    <div class="note">
                                      {{
                                        pack.statuses && pack.statuses.length
                                          ? pack.statuses[pack.statuses.length - 1].text
                                          : ''
                                      }}
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                        @if (column.propType === 'address-country' || column.propType === 'address-shipping') {
                          <span title="{{ column.title | translate }}">
                            @if (!!item[column.property]) {
                              <span>
                                {{ item[column.property].country }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'reservation-number') {
                          <span class="text-center" data-cy="reservation-number">
                            {{ item['reservationNumber'] }}
                          </span>
                        }
                        @if (column.propType === 'status') {
                          <span
                            class="status-div"
                            [ngClass]="'status-' + item.status?.id"
                            [title]="item?.status?.name | translate"
                          >
                            {{ item.status?.id | translate }}
                          </span>
                        }
                        @if (column.propType === 'stringArray') {
                          <div class="container-tags">
                            @for (item of item[column.property]; track item) {
                              <span
                                class="tag-span"
                                [ngStyle]="{ 'background-color': item.color ? item.color : '#0058FF', color: 'white' }"
                              >
                                {{ item.name }}
                              </span>
                            }
                          </div>
                        }
                        @if (column.propType === 'array-vertical') {
                          <span class="text-center" data-cy="array-vertical">
                            @if (item[column.property]?.length) {
                              <div class="badge bg-blue unavail-badge" style="position: absolute">
                                <i class="far fa-list"></i>
                                <div class="unavail-list-right">
                                  @for (it of item[column.property]; track it) {
                                    <div>{{ it | translate }}</div>
                                  }
                                </div>
                              </div>
                            }
                            &nbsp;
                          </span>
                        }
                        @if (column.propType === 'operation-type') {
                          <span class="text-center">
                            @if (item[column.property].id === 'in') {
                              <i
                                class="in-badge fas fa-plus-square"
                                title="{{ item[column.property].name | translate }}"
                              ></i>
                            }
                            @if (item[column.property].id === 'out') {
                              <i
                                class="out-badge fas fa-minus-square"
                                title="{{ item[column.property].name | translate }}"
                              ></i>
                            }
                            @if (item[column.property].id === 'transfer') {
                              <i
                                class="transfer-badge fas fa-exchange-alt"
                                title="{{ item[column.property].name | translate }}"
                              ></i>
                            }
                            @if (item[column.property].id === 'reservation') {
                              <i
                                class="reservation-badge fas fa-clock"
                                title="{{ item[column.property].name | translate }}"
                              ></i>
                            }
                            <!--                {{item[column.property].name | trans}}-->
                          </span>
                        }
                        @if (column.propType === 'depot-from-to') {
                          <span>
                            @if (item.depotFrom?.id) {
                              <span>
                                {{ (item.depotFrom.name?.length > 2 ? item.depotFrom.name : '') | translate }}
                              </span>
                            }
                            @if (item.depotFrom?.id && item.depotTo?.id) {
                              <span>/</span>
                            }
                            @if (item.depotTo?.id) {
                              <span>
                                {{ (item.depotTo.name?.length > 2 ? item.depotTo.name : '') | translate }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'types-with-values') {
                          <span>
                            @if (item.discountType) {
                              <span>
                                {{ item.discountType ?? '' | translate }}
                              </span>
                            }
                            @if (item.discountPercent) {
                              <span>
                                {{ item.discountPercent + '%' }}
                              </span>
                            }
                            @if (item.discountValue) {
                              <span>
                                {{ item.discountValue | formatPrice }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'used-maxUse') {
                          <span>
                            <span>
                              {{ item.used ?? 0 }}
                            </span>
                            <span>/</span>
                            @if (item.maxUse) {
                              <span>
                                {{ item.maxUse ?? 0 }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'batch-and-expiration' && item['move']) {
                          <span>
                            @if (item['move'].expirationDate) {
                              <span
                                >customer
                                {{ item['move'].expirationDate | fmtDate: 'dd.MM.yyyy' }}
                              </span>
                            }
                            @if (item['move'].expirationDate && item['move'].batch) {
                              <span>/</span>
                            }
                            @if (item['move'].batch) {
                              <span>
                                {{ item['move'].batch }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'fullName') {
                          <span>
                            @if (item.firstName) {
                              <span>
                                {{ item.firstName }}
                              </span>
                            }
                            @if (item.lastName) {
                              <span>
                                {{ item.lastName }}
                              </span>
                            }
                          </span>
                        }
                        @if (column.propType === 'notes') {
                          <span class="d-flex flex-column">
                            @if (item.note?.length) {
                              <span>
                                <!-- HTML to write -->
                                <span data-toggle="tooltip" title="{{ 'note' | translate }}:  {{ item.note }}">{{
                                  item.note
                                }}</span>
                                <!-- Generated markup by the plugin -->
                                <div class="tooltip bs-tooltip-top" role="tooltip">
                                  <div class="arrow"></div>
                                </div>
                              </span>
                            }
                            @if (item.privateNote?.length) {
                              <span>
                                <!-- HTML to write -->
                                <span
                                  data-toggle="tooltip"
                                  title="{{ 'note.private' | translate }}:  {{ item.privateNote }}"
                                  >{{ item.privateNote }}</span
                                >
                                <!-- Generated markup by the plugin -->
                                <div class="tooltip bs-tooltip-top" role="tooltip">
                                  <div class="arrow"></div>
                                </div>
                              </span>
                            }
                          </span>
                        }
                        <!--PIPES-->
                        @if (column.propType === 'pipe-order-items-price') {
                          <span title="{{ column.title | translate }}">
                            {{ item | orderItemsPriceSum }}&nbsp;{{
                              item.currency && item.currency.id
                                ? (item.currency.id | translate)
                                : (core.services.user?.user?.company?.currency | formatCurrencyWithoutPrice)
                            }}
                          </span>
                        }
                        <!--BUTTONS-->
                        @if (column.propType === 'btn' && !column.action && column.route) {
                          <span>
                            <a
                              [routerLink]="[column.route, item.id]"
                              class="btn-{{ column.btnStyle }} float-right ms-2"
                              [title]="column.name | translate"
                              data-cy="download-report"
                            >
                              <i class="far fa-{{ column.icon ? column.icon : 'file-o' }} me-2"></i>
                              {{ column.name | translate }}
                            </a>
                          </span>
                        }
                        @if (column.propType === 'btn' && column.action && !column.route) {
                          <span>
                            <!--Don't know why the linter wants to make a-tag "focusable", it always is-->
                            <a
                              tabindex="0"
                              class="btn-{{ column.btnStyle }} float-right ms-2"
                              [title]="column.name | translate"
                              data-cy="dowload-report"
                            >
                              <i class="far fa-{{ column.icon ? column.icon : 'file-o' }} me-2"></i>
                              {{ column.name | translate }}
                            </a>
                          </span>
                        }
                        @if (column.propType === 'btn-right' && !column.action && column.route) {
                          <span>
                            <a
                              [routerLink]="[column.route, item.id]"
                              [title]="column.name | translate"
                              [target]="column.target"
                              class="btn-{{ column.btnStyle }} float-right ms-2"
                              data-cy="open-row"
                            >
                              {{ column.name | translate }}
                              <i class="far fa-{{ column.icon ? column.icon : 'file-o' }} ms-2"></i>
                            </a>
                          </span>
                        }
                        @if (item.product?.id && column.propType === 'btn-orders') {
                          <span>
                            <a
                              [routerLink]="[column.route]"
                              [queryParams]="{
                                item: item?.code || item?.ean,
                                stringifiedFilters: stringifiedFilters
                              }"
                              [title]="column.name | translate"
                              class="btn-{{ column.btnStyle }} float-right ms-2"
                              data-cy="open-row"
                            >
                              <i class="far fa-shopping-cart"></i>
                            </a>
                          </span>
                        }
                        <!--                <span *ngIf="column.propType === 'btn-right' && column.action && !column.route">-->
                        <!--                  <a-->
                        <!--                    tabindex="0"-->
                        <!--                    class="btn-{{ column.btnStyle }} float-right ms-2"-->
                        <!--                    [title]="column.name | translate"-->
                        <!--                  >-->
                        <!--                    {{ column.name | translate }}-->
                        <!--                    <i class="far fa-{{ column.icon ? column.icon : 'chevron-right' }} ms-2"></i>-->
                        <!--                  </a>-->
                        <!--                </span>-->
                        @if (column.propType === 'btn-right' && column.action && !column.route) {
                          <span>
                            <a
                              tabindex="0"
                              class="btn-{{ column.btnStyle }} float-right ms-2"
                              (click)="onAction(column.action, item)"
                              (keydown)="onAction(column.action, item)"
                              [title]="column.name | translate"
                            >
                              {{ column.name | translate }}
                              <i class="far fa-{{ column.icon ? column.icon : 'chevron-right' }} ms-2"></i>
                            </a>
                          </span>
                        }
                        @if (column.propType === 'btn-gen' && column.action && !column.route) {
                          <span>
                            @if (!item.generated) {
                              <a
                                class="btn-second btn-sm float-right"
                                [title]="'reports.generating' | translate"
                                disabled
                              >
                                <i class="fa fa-spinner fa-spin me-2"></i>
                                {{ 'reports.generating' | translate }}
                              </a>
                            }
                            @if (item.generated) {
                              <a
                                class="btn-{{ column.btnStyle }} float-right ms-2"
                                tabindex="0"
                                (click)="onAction(column.action, item)"
                                (keydown)="onAction(column.action, item)"
                                [title]="column.name | translate"
                                data-cy="'btn-gen'"
                              >
                                <i
                                  class="far me-2"
                                  [ngClass]="{
                                    'fa-eye': !item.format,
                                    'fa-file-pdf': item.format === 'pdf',
                                    'fa-file-excel': item.format === 'excel'
                                  }"
                                ></i>
                                {{ column.name | translate }}
                              </a>
                            }
                          </span>
                        }
                        <!--MODALS-->
                        @if (column.propType === 'modal-address') {
                          <span>
                            <!--                  todo-->
                            <modal-address
                              [address]="item"
                              [customer]="item['customer']"
                              [isListingBtn]="true"
                            ></modal-address>
                          </span>
                        }
                        <!--CHECKBOXES-->
                        @if (column.propType === 'orders-checkbox') {
                          <span class="padding-td-checkbox">
                            <form-row-checkbox
                              [isOnOrdersPage]="true"
                              [model]="isOrderChecked(item.id)"
                              (modelChange)="orderWasChecked(item.id, $event)"
                              [cursorPointer]="true"
                              [dataCySelector]="'product-row-checkbox'"
                            >
                            </form-row-checkbox>
                          </span>
                        }
                      </td>
                    }
                  </tr>
                </tbody>
              }
              @if (listName() === 'exports' && formatFilters(item.filter)?.length) {
                <tbody [id]="'collapse_' + item.id" [class.show]="true">
                  <tr style="vertical-align: top !important">
                    <td colspan="5">
                      <div class="input-group-append flex-wrap product-center">
                        <div class="product-details" style="display: flex; margin-left: 1rem">
                          {{ 'base.listing.filters' | translate }}&nbsp;
                          <span>
                            @if (formatFilters(item.filter); as pairs) {
                              <div class="export-filters">
                                @for (p of pairs; track p; let last = $last) {
                                  <span class="filter-label fw-bold">{{ p.label | translate }}:</span>&nbsp;
                                  <span class="filter-value">{{ p.value }}</span
                                  >&nbsp;
                                  @if (!last) {
                                    <span>, </span>
                                  }
                                }
                              </div>
                            }
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              }
            }
          </table>
          @if (nextButtonShow() && !loadingFirstPage()) {
            <app-pagination-btn (switchPage)="query().fetchNextPage()" [loadingPage]="loadingNextPage()">
            </app-pagination-btn>
          }
        </div>
      }
    </div>
  </div>
</div>
